import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Scroll to top instantly on every route change
    // This prevents smooth scroll animations from triggering during navigation
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
